import { render, staticRenderFns } from "./pendingBetListWBetTab.vue?vue&type=template&id=4f438b9f&lang=pug"
import script from "./pendingBetListWBetTab.vue?vue&type=script&lang=js"
export * from "./pendingBetListWBetTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports